import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnInit} from '@angular/core';
import { IMessengerConnector, Message } from '../../../../types/all.type';
import { AllService } from '../../../../services/all.service';
import { DatePipe } from '@angular/common';
import { log } from '../../../../functions';
import {InterfaceService} from "../../../../services/interface.service";

@Component({
  selector: 'app-message-compact',
  templateUrl: './message-compact.component.html',
  styleUrls: ['./message-compact.component.scss', '../message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageCompactComponent implements OnInit {
  @Input() Service: IMessengerConnector;
  @Input() message: Message;
  @Input() lvl = 0;
  @Input() type = 'self';
  constructor(
    public interfaceService: InterfaceService,
    private datePipe: DatePipe,
    private allService: AllService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.cd.detach();
    if (this.message.text?.length > 0) {
      this.message.text = this.message.text.replace(/(<([^>]+)>)/gi, '');
    }
    this.lvl++;

    this.cd.detectChanges();
  }
  onClick(event) {
    log(this.message, 'onClick');
    this.interfaceService.scrollToMessage$.next(this.message);
  }
}
